import json from './sprite.js';

export default {
    handle: 'SP_NarratorVideo',
    label: 'es_ER-NarratorVideo_235073245',
    json,
};
